import Alert from "./Alert";

const WarningAlert = props => (
  <Alert severity="warning" {...props}/>
);

export default WarningAlert;
